const WebstorePriceTiers = {
    BUDGETFRIENDLYVALUE: 1,
    STANDARDVALUE: 2,
    PREMIUMVALUE: 3,
    LUXURYVALUE: 4,
};

export { WebstorePriceTiers };
